export interface LiveSession {
  id: number;
  title: string;
  date: string;
  time: string;
  description?: string;
  accessLevels: ('Uni' | 'First' | 'Manager')[];
  batches: number[]; // Which batches can access this session
  videoId?: string; // Bunny.net video ID
  videoTitle?: string; // Title for the video
  videoDescription?: string; // Description for the video
  hasRecording?: boolean; // Whether this session has a recording available
}

export const LIVE_SESSIONS: LiveSession[] = [
  {
    id: 27,
    title: 'Live Session 2',
    date: 'Saturday, 5 July 2025',
    time: '10:00 WIB',
    accessLevels: ['Uni', 'First', 'Manager'],
    batches: [1, 2, 3, 4, 5, 6, 7,10], // Available to previous batches
    videoId: '35758013-1c79-4986-beee-0f9229a0dd6d',
    videoTitle: 'Live Session 2 - Full Recording',
    videoDescription: 'Complete recording of Live Session 2.',
    hasRecording: true
  },
  {
    id: 37,
    title: 'Live Session 3',
    date: 'Saturday, 12 July 2025',
    time: '10:00 WIB',
    accessLevels: ['First', 'Manager'],
    batches: [1, 2, 3, 4, 5, 6, 7,10], // Available to previous batches
    videoId: '1b9b9f73-3e61-45c5-aedf-ff4ddbaa4f46',
    videoTitle: 'Live Session 3 - Full Recording',
    videoDescription: 'Complete recording of Live Session 3.',
    hasRecording: true
  },
  {
    id: 57,
    title: 'Live Session 5',
    date: 'Saturday, 19 July 2025',
    time: '10:00 WIB',
    accessLevels: ['Manager'],
    batches: [1, 2, 3, 4, 5, 6, 7,10], // Available to previous batches
    videoId: '29cf8e02-6bf2-4b2f-9d5c-c9dfd08fa97b',
    videoTitle: 'Live Session 5 - Full Recording',
    hasRecording: true
  },
  {
    id: 67,
    title: 'Live Session 6',
    date: 'Saturday, 26 July 2025',
    time: '10:00 WIB',
    accessLevels: ['Uni', 'First', 'Manager'],
    batches: [1, 2, 3, 4, 5, 6, 7,10], // Available to previous batches
    videoId: '3384055e-4d44-4454-aa70-14a393ab8708',
    videoTitle: 'Live Session 6 - Full Recording',
    hasRecording: true // This session hasn't happened yet, so no recording
  },
  {
    id: 81,
    title: 'Batch 8 - Live Session 1',
    date: 'Saturday, 9 August 2025',
    time: '10:00 WIB',
    accessLevels: ['Uni', 'First', 'Manager'],
    batches: [8], 
    videoId: '89e6a2fe-244f-4da0-89ce-38ee143e29ae',
    videoTitle: 'Live Session 1 - Full Recording',
    hasRecording: true
  },
  {
    id: 82,
    title: 'Batch 7 - Live Session 2',
    date: 'Saturday, 12 July 2025',
    time: '10:00 WIB',
    accessLevels: ['First', 'Manager'],
    batches: [8], 
    videoId: '1b9b9f73-3e61-45c5-aedf-ff4ddbaa4f46',
    videoTitle: 'Live Session 2 - Full Recording',
    hasRecording: true
  },
  {
    id: 83,
    title: 'Batch 8 - Live Session 3',
    date: 'Saturday, 23 August 2025',
    time: '10:00 WIB',
    accessLevels: ['Manager'],
    batches: [8], 
    videoId: 'd2691aae-7b74-43e3-a130-33c8cf02e080',
    videoTitle: 'Live Session 3 - Full Recording',
    hasRecording: true
  },
  {
    id: 84,
    title: 'Batch 8 - Live Session 4',
    date: 'Saturday, 30 August 2025',
    time: '10:00 WIB',
    accessLevels: ['Uni', 'First', 'Manager'],
    batches: [8], 
    videoTitle: 'Live Session 4 - Full Recording',
    videoId: 'ff858665-8bd7-4520-8b0d-7cf95bc1226c',
    hasRecording: true,
  },
  {
    id: 2,
    title: 'Batch 9 - Live Session M2',
    date: 'Saturday, 13 September 2025',
    time: '10:00 WIB',
    accessLevels: ['Uni', 'First', 'Manager'],
    batches: [9], 
    videoId: '9b5c4245-574d-4922-a4c2-71933ebe717e',
    videoTitle: 'Live Session M2 - Full Recording',
    hasRecording: true
  },
  {
    id: 3,
    title: 'Batch 9 - Live Session M3',
    date: 'Saturday, 20 September 2025',
    time: '10:00 WIB',
    accessLevels: ['First', 'Manager'],
    batches: [9], 
    videoId: 'c26cd260-764f-49b3-8a34-ecd58ec4579a',
    videoTitle: 'Live Session M3 - Full Recording',
    hasRecording: true
  },

  {
    id: 5,
    title: 'Batch 9 - Live Session M5',
    date: 'Saturday, 27 September 2025',
    time: '10:00 WIB',
    accessLevels: ['Manager'],
    batches: [9], 
    videoId: 'a7b443f1-efab-463d-9b3a-e0122db55ff4',
    videoTitle: 'Live Session M5 - Full Recording',
    hasRecording: true
  },
  {
    id: 6,
    title: 'Batch 9 - Live Session M6',
    date: 'Saturday, 4 October 2025',
    time: '10:00 WIB',
    accessLevels: ['Manager'],
    batches: [9], // Only available to current batch
    videoId: '02eb5a93-ab9c-4f5b-aeb2-7e31f8376faa',
    videoTitle: 'Live Session M6 - Full Recording',
    hasRecording: true
  }
];

export const getAvailableLiveSessions = (accessLevel: string, userBatch?: number): LiveSession[] => {
  return LIVE_SESSIONS.filter(session => {
    // Check if user has the required access level
    const hasAccessLevel = session.accessLevels.includes(accessLevel as 'Uni' | 'First' | 'Manager');
    
    // If batch is not provided, fall back to old behavior for backward compatibility
    if (userBatch === undefined) {
      return hasAccessLevel;
    }
    
    // Check if user's batch has access to this session
    const hasBatchAccess = session.batches.includes(userBatch);
    
    // Special handling for batch 8 users with empty/invalid access levels
    // Allow them to see at least Session 8 if they're in batch 8
    if (userBatch === 8 && !accessLevel && session.id === 8) {
      return true;
    }
    
    return hasAccessLevel && hasBatchAccess;
  });
}; 